import React, { useState } from "react";
import Cookies from "js-cookie";
import BASE_URL from "../config";
import axios from "axios";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import SelectDropdown from "../SelectDropdown";
import creditNoteMainDropData from "../data/creditNoteSearch.json";
import BillTable from "../BillTableView";
import { ToastContainer, toast } from "react-toastify";

import "react-toastify/dist/ReactToastify.css";

const CreditNote = () => {
    const storedToken = Cookies.get("authToken");
    const storedUser = Cookies.get("authUser");
    const [authtoken, setAuthToken] = useState(storedToken || "");
    const [authUser, setAuthUser] = useState(storedUser || "");
    const [pageComponent, setPageComponent] = useState("search/search_creditNote_by/");
    const [secondaryDropDownData, setSecondaryDropDownData] = useState(undefined);
    const [searchData, setSearchData] = useState([]);
    const [tableItems, setTableItems] = useState([]);
    const [validateFeildItems, setvalidateFeildItems] = useState([]);
    const [selectedRow, setSelectedRow] = useState(null); // Track the selected row

    const serviceOptions = creditNoteMainDropData ?
        creditNoteMainDropData.map((searchItem) => ({
            value: searchItem.dataId,
            label: searchItem.labelName,
        })) : [];

    const valueServiceOrigin = async (event) => {
        setTableItems([]);
        setSearchData({ ...searchData, SearchBy: event.value });
        if (event.value) {
            await axios
                .get(`${BASE_URL}${pageComponent}${event.value}`, {
                    method: "GET",
                    headers: {
                        Authorization: `Bearer ${authtoken}`,
                    },
                })
                .then((response) => {
                    setSecondaryDropDownData(response.data.data);
                });
        }
    }

    const secondDropdownDataCall = async (event) => {
        setTableItems([]);
        setSearchData({ ...searchData, id: event.value });
    }

    const secondaryOptions = secondaryDropDownData ?
        secondaryDropDownData.map((secondItem) => ({
            value: secondItem.id,
            label: secondItem.desc,
        })) : [];

    const findData = async () => {
        if (searchData.SearchBy === undefined) {
            toast.error("Please select Search Category", {
                position: toast.POSITION.TOP_RIGHT,
            });
            setvalidateFeildItems(prevItems => [...prevItems, "priveDropdown"]);
        } else if (searchData.id === undefined) {
            setvalidateFeildItems(prevItems => prevItems.filter(item => item !== "priveDropdown"));
            toast.error("Please select Search Items", {
                position: toast.POSITION.TOP_RIGHT,
            });
            setvalidateFeildItems(prevItems => [...prevItems, "secondaryDropdown"]);
        } else {
            setvalidateFeildItems(prevItems => prevItems.filter(item => item !== "priveDropdown"));
            setvalidateFeildItems(prevItems => prevItems.filter(item => item !== "secondaryDropdown"));

            if (Object.keys(searchData).length > 0) {
                try {
                    const response = await axios.get(`${BASE_URL}search/search_creditNote_by`, {
                        params: searchData,
                        headers: {
                            Authorization: `Bearer ${authtoken}`,
                        },
                    });

                    setTableItems(response.data.data);
                } catch (error) {
                    console.error("Error fetching data:", error);
                }
            }
        }
    };

    const handleGenerateReport = async (row) => {
        try {
            // Prepare the data to be sent to the API
            const requestData = {
                ...row,
            };

            const response = await axios.post(`${BASE_URL}search/search_creditnote_by/get_report`, requestData, {
                headers: {
                    Authorization: `Bearer ${authtoken}`,
                },
                responseType: 'blob',
            });

            const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'Credit_Note_Report.pdf');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            console.error("Error generating report:", error);
            toast.error("Error generating report. Please try again.", {
                position: toast.POSITION.TOP_RIGHT,
            });
        }
    };

    const headercolumns = [
        "Credit Note No",
        "Invoice No",
        "Invoice Amount",
        "Customer",
        "Booking No",
        "Get Report",
        "View Document",
    ];
    const columns = [
        "credit_note_number",
        "invoice_number",
        "amount",
        "customer_name",
        "booking_number",
        "get_report",
        "view_document",
    ];

    return (
        <Container fluid>
            <ToastContainer autoClose={2000} />
            <Row>
                <Col>
                    <Form className="mt-3 bottom-border pb-3">
                        <Row>
                            <Col>
                                <Form.Group className="mb-3">
                                    <SelectDropdown
                                        options={serviceOptions}
                                        onChange={valueServiceOrigin}
                                        clName={validateFeildItems.includes("priveDropdown") ? "border-red2" : ""}
                                    />
                                </Form.Group>
                            </Col>
                            <Col className="text-end">
                                <Form.Group className="mb-3 text-start">
                                    <SelectDropdown
                                        options={secondaryOptions}
                                        onChange={secondDropdownDataCall}
                                        clName={validateFeildItems.includes("secondaryDropdown") ? "border-red2" : ""}
                                    />
                                </Form.Group>
                                <Button className="text-right" variant="primary" type="button" onClick={findData}>
                                    Search
                                </Button>
                            </Col>
                        </Row>
                    </Form>
                </Col>
            </Row>
            <Row className="mt-4">
                <Col>
                    <BillTable
                        data={tableItems}
                        columns={columns}
                        headercolumns={headercolumns}
                        setSelectedRow={setSelectedRow}
                        buttonLabel="Get Report"
                        buttonAction={handleGenerateReport}
                    />
                </Col>
            </Row>
        </Container>
    );
};

export default CreditNote;
